import gql from "graphql-tag";

export default gql`
  query CommonAssets(
    $customerId: ID
    $offset: Int
    $limit: Int
    $orderByCreationDate: String
    $orderByCodename: String
    $orderByLastUsed: String
    $format: String
    $categoryIds: [String]
  ) {
    commonAssets(
      customerId: $customerId
      offset: $offset
      limit: $limit
      orderByCreationDate: $orderByCreationDate
      orderByCodename: $orderByCodename
      orderByLastUsed: $orderByLastUsed
      format: $format
      categoryIds: $categoryIds
    ) {
      items {
        id
        customerId
        codename
        format
        hasGraphicsets
        sizePx {
          x
          y
        }
      }
      total
    }
  }
`;
